// The one dismiss cross on this page — the member chip, the design thumbnail and the preview.
//
// An SVG rather than the `×` character: U+00D7 is a maths glyph sitting on the maths axis, so it
// rides high in a round button and no amount of line-height centres it across fonts. Its stroke
// also inherits the font weight, which at 11-13px left a hairline inside a solid circle. Two
// strokes at a fixed width fix the weight and the centring at once.
import React from 'react';

const CloseButton = ({ size = 18, className = '', label = 'Remove', onClick }) => (
  <button
    type="button"
    className={`x-btn ${className}`.trim()}
    style={{ width: size, height: size }}
    aria-label={label}
    title={label}
    onClick={onClick}
  >
    <svg
      width={Math.round(size * 0.52)}
      height={Math.round(size * 0.52)}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      aria-hidden="true"
    >
      <path d="M18 6 6 18M6 6l12 12" />
    </svg>
  </button>
);

export default CloseButton;
